// utils/ppnLogStorage.js
export const PPN_LOG_NAMESPACE = 'ppn-activity-logs';

// Generate log key
export const getLogKey = (objectiveId, week) => {
  return `${objectiveId}_${week}`;
};

// Save PPN activity log
export const savePPNActivityLog = async (engine, key, logData) => {
  try {
    // Get existing logs
    const existing = await loadPPNActivityLog(engine, key);
    
    // Add new log entry
    const logs = existing || [];
    logs.push({
      ...logData,
      timestamp: new Date().toISOString(),
      logId: `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
    });
    
    // Keep last 100 entries to prevent excessive storage
    const trimmedLogs = logs.slice(-100);
    
    await engine.mutate({
      resource: `dataStore/${PPN_LOG_NAMESPACE}/${key}`,
      type: 'update',
      data: {
        logs: trimmedLogs,
        lastUpdated: new Date().toISOString()
      }
    });
    
    return trimmedLogs;
  } catch (error) {
    // If update fails, try create
    if (error.message?.includes('404') || error.httpStatus === 404) {
      await engine.mutate({
        resource: `dataStore/${PPN_LOG_NAMESPACE}/${key}`,
        type: 'create',
        data: {
          logs: [logData],
          lastUpdated: new Date().toISOString()
        }
      });
      return [logData];
    }
    throw error;
  }
};

// Load PPN activity logs
export const loadPPNActivityLog = async (engine, key) => {
  try {
    const response = await engine.query({
      logs: {
        resource: `dataStore/${PPN_LOG_NAMESPACE}/${key}`,
      }
    });
    return response.logs?.logs || [];
  } catch (error) {
    if (error.message?.includes('404') || error.httpStatus === 404) {
      return [];
    }
    throw error;
  }
};

// Get specific log entry by ID
export const getPPNLogEntry = async (engine, key, logId) => {
  const logs = await loadPPNActivityLog(engine, key);
  return logs.find(log => log.logId === logId) || null;
};

// Log PPN action
export const logPPNAction = async (engine, objectiveId, week, action, details, user) => {
  const key = getLogKey(objectiveId, week);
  
  const logEntry = {
    action: action, // 'created', 'updated', 'completed', 'file_uploaded', 'file_removed', 'status_changed'
    details: details,
    user: {
      id: user?.id || 'unknown',
      name: user?.displayName || user?.username || 'Unknown User'
    },
    objectiveId: objectiveId,
    week: week
  };
  
  return await savePPNActivityLog(engine, key, logEntry);
};